import {Price} from "../domin/pay/Price";

// Hablo 应用下载链接
export const HABLO_APP_DOWNLOAD_URL = "https://habloai.go.link/1xbe9";
export const GOOGLE_DOWNLOAD_URL = "https://play.google.com/store/apps/details?id=ai.hablo.languagelearning";
export const APPLE_DOWNLOAD_URL = "https://apps.apple.com/us/app/hablo-language-learning-tutor/id6464555526";

export const PRIVACY_POLICY_URL = "https://dailywords-app-service.pixelcell.com/static/privacy_policy.html";
export const USER_AGREEMENT_URL = "https://dailywords-app-service.pixelcell.com/static/user_agreement.html";

export const TRACKING_PRODUCT_CODE = "justfit";
// 环境常量
export const PROD = "production";
export const STAGE = "stage";
export const DEV = "development";

// host 配置
export const PROD_API_HOST = "https://app-service.justfit.ai";
export const STAGE_API_HOST = "https://app-service-stage.justfit.ai";

export const PROD_WEB_HOST = "https://justfit.com";
export const STAGE_WEB_HOST = "https://website-stage.justfit.com";

export const COUNTRY_API =  "https://gw.justfit.com/ip/api/v1/ip/ip2country";
export const COUNTRY_STAGE_API =  "https://gw-stage.justfit.com/ip/api/v1/ip/ip2country";



// 图片处理配置
export const IMAGE_PREFIX = 'image-handle/';
export const IMAGE_VERSION = '1.0';

// 环境判断函数
export const getEnvironment = () => {
    if (process.env.BUILD_ENV === 'production') {
        return PROD;
    } else if (process.env.BUILD_ENV === 'stage') {
        return STAGE;
    } else {
        return DEV;
    }
};

// 环境配置
export const ENV_CONFIG = {
    [PROD]: {
        imageBaseUrl: PROD_WEB_HOST,
        imageProcess: {
            prefix: IMAGE_PREFIX,
            version: IMAGE_VERSION,
            quality: 85,
            format: 'webp'
        },
        apiBaseUrl: PROD_WEB_HOST
    },
    [STAGE]: {
        imageBaseUrl: STAGE_WEB_HOST,
        imageProcess: {
            prefix: IMAGE_PREFIX,
            version: IMAGE_VERSION,
            quality: 90,
            format: 'webp'
        },
        apiBaseUrl: STAGE_WEB_HOST
    },
    [DEV]: {
        imageBaseUrl: 'http://localhost:3000',
        imageProcess: {
            prefix: '',
            version: '',
            quality: 100,
            format: 'png'
        },
        apiBaseUrl: 'http://localhost:8080'
    }
};

// 获取当前环境配置
export const getCurrentEnvConfig = () => {
    const env = getEnvironment();
    return ENV_CONFIG[env] || ENV_CONFIG[DEV];
};


export const SKUS = [{
    discount: 0,
    prices: [
        new Price(1, 17.77, "P-0HT19148771797008NBH3EJA", "prod_SVWhAAmTRPcqRG"),
        new Price(4, 38.95, "P-0HT19148771797008NBH3EJA", "prod_SVWlfWCUeEeQYc"),
        new Price(12, 66.65, "P-0HT19148771797008NBH3EJA", "prod_SVWm2GxizDqnsP"),
    ]
},{
    discount: 69,
    prices: [
        new Price(1, 6.93, "P-40L5321349043071BNBH3FVI", "prod_SVWhAAmTRPcqRG"),
        new Price(4, 15.19, "P-7AJ211098C227813PNBH3GCQ", "prod_SVWlfWCUeEeQYc"),
        new Price(12, 25.99, "P-44U69739P5457513WNBH3GPA", "prod_SVWm2GxizDqnsP"),
    ]
},{
    discount: 71,
    prices: [
        new Price(1, 5.15, "P-81G429675F749014BNBH3HDQ", "prod_SVWhAAmTRPcqRG"),
        new Price(4, 11.29, "P-7H567642A63678531NBH3HRI", "prod_SVWlfWCUeEeQYc"),
        new Price(12, 19.29, "P-0MX52635EN594660DNBH3H2Y", "prod_SVWm2GxizDqnsP"),
    ]
}]
